import {CookieService} from '../services/cookie.service';
import {FacebookCookieService} from '../services/facebook-cookie.service';

interface ParamConfig {
    urlParam: string;
    cookieName: string;
    valueProcessor: (value: string) => string;
    overrideGuard?: (oldValue: string | undefined, newProcessedValue: string, rawValue: string) => boolean;
}

/**
 * This class is responsible for catching the params from the URL and storing them in a cookie.
 * !IMPORTANT there is a similiar/equal class for b2c, consider updating / keeping it in sync
 */
export class QueryCatcher {
    static readonly STRING_PARAMS: string[] = [
        'gclid',
        'gbraid',
        'wbraid',
        'msclkid',
        'utm_campaign',
        'utm_medium',
        'utm_source',
        'utm_content',
        'utm_term',
    ];

    static readonly PROCESSABLE_PARAMS: ParamConfig[] = [
        {
            urlParam: 'fbclid',
            cookieName: '_fbc',
            valueProcessor: (value: string): string => FacebookCookieService.formatFbcValue(value),
            overrideGuard: (oldValue: string | undefined, newProcessedValue: string, rawValue: string): boolean =>
                FacebookCookieService.shouldOverrideFbc(oldValue, newProcessedValue, rawValue)
        },
    ];

    public static saveInCookies(): void {
        const urlParams = new URLSearchParams(window.location.search);
        
        QueryCatcher.STRING_PARAMS.forEach(function (paramName) {
            const newValue = urlParams.get(paramName);
            if (newValue) {
                CookieService.setCookie(paramName, newValue, 365);
            }
        });
        
        QueryCatcher.PROCESSABLE_PARAMS.forEach(function (config) {
            const newValue = urlParams.get(config.urlParam);
            
            if (newValue) {
                const processedValue = config.valueProcessor(newValue);
                
                if (config.overrideGuard) {
                    const oldValue = CookieService.getCookie(config.cookieName);
                    if (!config.overrideGuard(oldValue, processedValue, newValue)) {
                        return;
                    }
                }
                
                CookieService.setCookie(config.cookieName, processedValue, 365);
            }
        });
    }

    public static saveInLocalStorage(): void {

        if (!localStorage) {
            return;
        }


        const urlParams = new URLSearchParams(window.location.search);
        
        QueryCatcher.STRING_PARAMS.forEach(function (paramName) {
            const newValue = urlParams.get(paramName);
            if (newValue) {
                localStorage.setItem(paramName, newValue);
            }
        });
        
        QueryCatcher.PROCESSABLE_PARAMS.forEach(function (config) {
            const newValue = urlParams.get(config.urlParam);
            if (newValue) {
                localStorage.setItem(config.urlParam, newValue);
            }
        });
    }
}

window.addEventListener('load', () => {
    QueryCatcher.saveInCookies();
    QueryCatcher.saveInLocalStorage();
});
